<template>
  <div id="DistList" class="bg-color1" style="height:calc(100vh);">
    <div ref="app_head" class="col-12 lh40 bg-color-white b-s-2 pl5 pr5 fixed-t">
        <div class="col-3 f18" @click="$router.back(-1)"><i class="iconfont icon-31fanhui1 color-primary"></i></div>
        <div class="col-6 t-c color-primary"><span class="f24 fw">D</span>istribuidores</div>
        <div class="col-3 t-r f26"></div>
    </div>
    <div class="h4"></div>
    <div class="col-12">
      <div class="col-12 mt5" v-for="(dist,dist_i) in data_list" v-bind:key="dist_i" @click="go_dist(dist.aid)">
        <div class="col-12">
          <div class="col-12 bg-color-white p5">
              <div class="col-2 f40 color-primary t-c">
                <img v-bind:src="dist.avatar" v-if="dist.avatar">
                <img src="@/assets/user.png" v-else class="w5 r50">
              </div>
              <div class="col-9 pl10">
                <div class="col-12 f16 uppercase pt10 pb2"><span class="bg-color-warning color-white f12 pt1 pb1 pl3 pr3 r5">L.{{dist.account_grade}}</span> {{ dist.name }}</div>
                <div class="col-12 color-muted f12">{{ dist.last_time}}</div>
              </div>
              <div class="col-1 color-muted t-r lh50"><i class="iconfont icon-31fanhui2"></i></div>
          </div>
        </div>
      </div>
    </div>
    <div ref="app_foot" class="col-12 fixed-b t-c color-white f14 bg-color1 t-c-v">
    </div>
  </div>
</template>
<script>
export default {
  name: 'DistList',
  data () {
    return {
      aid: '',
      data_list: [],
    }
  },
  created: function () {
    this.aid = this.$route.query.aid;
    this.get_list_data();
  },
  methods: {
    get_list_data() {
      var post_data = {};
      post_data.aid = this.aid;
      this.post(this.api_url + 'Agent/dist_list', post_data).then((res)=>{
        if(res.status == 1){
          this.data_list = res.data;
        }
      })
    },
    go_dist(aid){
      this.$router.push({name:'Dist',query:{aid: aid}});
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Agent/DistList.vue